import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchGroupChartData = (groupIds: string[]) =>
    RESTClient.getAuthenticatedObservable('daycareadmin/chart/chartForGroups', {
        groupIds,
    });

export const fetchTagChartData = (tagId: string) => {
    return RESTClient.getAuthenticatedObservable('daycareadmin/chart/chartfortag', {
        tagId,
    });
};
